export default "__VITE_ASSET__CNWSHdaD__"